import { until } from '@vueuse/core'
import type { LinkedModuleBuilds } from '@webapp2/shared/model'
import { registeredStateId, state } from '../state'
import {
  isEmbeddedOrSceneModule,
  launch2,
  registerModules,
  type BuildLaunchData,
  type MultiplayerLaunchData,
  type SingleLaunchData
} from './quest-bridge'

function isModuleReady(link: LinkedModuleBuilds) {
  if (isEmbeddedOrSceneModule(link.techniquePath)) {
    return true
  }
  const registered = state.registeredStates[registeredStateId(link.techniquePath)]
  return registered?.linkedModuleBuildsId === link.id && registered.downloadStatus?.state === 'Downloaded'
}

export function ensureModulesRegistered(links: LinkedModuleBuilds[]) {
  const remoteLinks = links.filter(link => !isEmbeddedOrSceneModule(link.techniquePath))
  if (remoteLinks.length > 0) {
    registerModules({ builds: remoteLinks })
  }
}

export type LaunchModuleOptions = {
  build: BuildLaunchData
  link?: LinkedModuleBuilds
  courseId?: string
  isTestMode: boolean
  runTutorial: boolean
  tutorial?: BuildLaunchData
}

export function launchModule({ build, link, courseId, isTestMode, runTutorial, tutorial }: LaunchModuleOptions) {
  if (link) {
    ensureModulesRegistered([link])
  }
  const playlist: SingleLaunchData[] = []
  if (runTutorial && tutorial) {
    playlist.push({ type: 'SinglePlayer', build: tutorial, courseId, isTestMode: false, runTutorial })
  }
  playlist.push({ type: 'SinglePlayer', build, courseId, isTestMode, runTutorial })
  launch2({ playlist })
}

export type JoinSessionOptions = {
  link: LinkedModuleBuilds
  multiplayerSessionId: string
  address: string
  inviteCode: string
  courseId?: string
  preJoinBuilds: BuildLaunchData[]
}

export async function joinMultiplayerSession({
  link,
  multiplayerSessionId,
  address,
  inviteCode,
  courseId,
  preJoinBuilds
}: JoinSessionOptions) {
  ensureModulesRegistered([link])
  await until(() => isModuleReady(link)).toBe(true)
  const playlist: (SingleLaunchData | MultiplayerLaunchData)[] = [
    ...preJoinBuilds.map<SingleLaunchData>(build => ({
      type: 'SinglePlayer',
      build,
      courseId,
      isTestMode: false,
      runTutorial: false
    })),
    { type: 'Multiplayer', address, inviteCode, multiplayerSessionId, courseId }
  ]
  launch2({ playlist })
}
